import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';
import { toObservable } from '@angular/core/rxjs-interop';
import { environment } from '../../../../environments/environment';
import {
  IRegisterResponse,
  ITokenInformation,
  IRegisterUser,
} from '../interfaces';
import { AuthResponse } from '../../login/interfaces';
import { AppStore } from '../../../app.store';

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  private readonly apiUrl = `${environment.apiUrl}`;
  private readonly appStore = inject(AppStore);

  readonly #http = inject(HttpClient);

  register(dto: IRegisterUser): Observable<IRegisterResponse> {
    return this.#http.post<IRegisterResponse>(
      this.apiUrl + '/auth/bulk-register',
      {
        users: [dto],
        clientId: this.appStore.clientConfig()?._id,
      },
    );
  }

  getUserInformation(token: string): Observable<ITokenInformation> {
    return toObservable(this.appStore.clientConfig).pipe(
      filter(config => !!config),
      take(1),
      switchMap(config => 
        this.#http.put<ITokenInformation>(
          this.apiUrl + '/auth/get-pending-user',
          {
            token,
            clientId: config!._id,
          },
        )
      )
    );
  }

  deleteRegisterToken(token: string): Observable<AuthResponse> {
    return this.#http.delete<AuthResponse>(
      this.apiUrl + '/auth/delete-register-token',
      {
        body: { token },
      },
    );
  }
}
